import {
  FETCH_LIST,
  LIST_FETCHED,
  SHOW_INFO_DIALOG,
  HIDE_INFO_DIALOG,
  SHOW_SAVE_DIALOG,
  UPDATED,
  TOGGLE_LOADING,
  SET_ACTIVE_STATE,
  SHOW_MANAGER_EXT_DIALOG,
  FETCH_GROUP_MANAGER,
  GROUP_MANAGER_FETCHED
} from './actionTypes'

export const fetchList = (params, tenantd) => ({
  type: FETCH_LIST,
  payload: {
    params,
    tenantd,
  }
})

export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const groupManagerFetched = result => ({
  type: GROUP_MANAGER_FETCHED,
  payload: result
})

export const fetchGroupManager = params => ({
  type: FETCH_GROUP_MANAGER,
  payload: { params }
})

export const showSaveDialog = params => ({
  type: SHOW_SAVE_DIALOG,
  payload: { params }
})

export const showInfoDialog = params => ({
  type: SHOW_INFO_DIALOG,
  payload: { params }
})

export const hideInfoDialog = () => ({
  type: HIDE_INFO_DIALOG
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updated = (id, data) => ({
  type: UPDATED,
  payload: { id, data }
})

export const setActiveState = (id, isActive) => ({
  type: SET_ACTIVE_STATE,
  payload: { id, isActive }
})

export const showManagerExtDialog = params => ({
  type: SHOW_MANAGER_EXT_DIALOG,
  payload: { params }
})
